import script from "./ModalEliminarRondaTorneo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalEliminarRondaTorneo.vue?vue&type=script&setup=true&lang=ts"

import "./ModalEliminarRondaTorneo.vue?vue&type=style&index=0&id=972bf8ce&lang=css"

const __exports__ = script;

export default __exports__